/**
 * Tipos de erro compartilhados entre camadas.
 *
 * ValidationError: erro de regra de negócio destinado ao usuário final
 * (ex.: "Já existe um negócio com este título"). São esperados e NÃO
 * devem virar registro em platform_logs nem notificação no Telegram —
 * o toast da mutation já informou o usuário.
 *
 * Use sempre `new ValidationError(msg)` em vez de `new Error(msg)` quando
 * a mensagem é UX-facing e não representa um bug de sistema.
 */
export class ValidationError extends Error {
  readonly isValidationError = true as const;

  constructor(message: string, options?: { cause?: unknown }) {
    super(message, options);
    this.name = 'ValidationError';
  }
}

export function isValidationError(value: unknown): value is ValidationError {
  if (value instanceof ValidationError) return true;
  // Cruzando fronteira SSR ⇄ client ⇄ worker, `instanceof` às vezes falha
  // (duas instâncias da classe em realms diferentes). Checa pela marca.
  return (
    typeof value === 'object' &&
    value !== null &&
    (value as { isValidationError?: unknown }).isValidationError === true
  );
}
